module.exports = __webpack_public_path__ + "img/appointmentonline.ebcd26e9.png";